<div class="contact">
  <div class="header">
    <app-navbar></app-navbar>
    <app-contact-header></app-contact-header>
  </div>
  <app-open-hours></app-open-hours><br />
  <app-footer></app-footer>
</div>
